export default "__VITE_ASSET__AsFALiR8IeZG9JJmQmaurw__"